import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "header-search" };
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "search-input-wrapper" };
const _hoisted_4 = {
    key: 0,
    class: "search-results"
};
const _hoisted_5 = {
    key: 0,
    class: "search-loading"
};
const _hoisted_6 = {
    key: 1,
    class: "search-error"
};
const _hoisted_7 = {
    key: 2,
    class: "results-list"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = {
    key: 0,
    class: "result-image"
};
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = { class: "result-content" };
const _hoisted_12 = { class: "result-title" };
const _hoisted_13 = {
    key: 3,
    class: "no-results"
};
import { ref, nextTick, watch } from 'vue';
import axios from 'axios';
import { useAssets } from '../../composables/useAssets';
const API_ENDPOINT = '/api/oil-finder/search';
const DEBOUNCE_MS = 300;
// State
export default /*@__PURE__*/ _defineComponent({
    __name: 'HeaderSearch',
    setup(__props) {
        const { assetUrl } = useAssets();
        const isSearchOpen = ref(false);
        const searchQuery = ref('');
        const searchResults = ref([]);
        const isSearching = ref(false);
        const searchError = ref(null);
        const searchInput = ref(null);
        // Debounce timer
        let searchTimeout = null;
        // Toggle search overlay
        const toggleSearch = () => {
            isSearchOpen.value = !isSearchOpen.value;
            if (isSearchOpen.value) {
                document.body.style.overflow = 'hidden';
                nextTick(() => {
                    searchInput.value?.focus();
                });
            }
            else {
                document.body.style.overflow = '';
                searchQuery.value = '';
                searchResults.value = [];
                searchError.value = null;
            }
        };
        // Close search
        const closeSearch = () => {
            isSearchOpen.value = false;
            document.body.style.overflow = '';
            searchQuery.value = '';
            searchResults.value = [];
            searchError.value = null;
        };
        // Handle search with debounce
        const handleSearch = () => {
            // Clear any existing timeout
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            // Clear error
            searchError.value = null;
            // If query is empty, reset results
            if (searchQuery.value.length === 0) {
                searchResults.value = [];
                isSearching.value = false;
                return;
            }
            // Set loading state
            isSearching.value = true;
            // Set debounced search
            searchTimeout = setTimeout(async () => {
                await performSearch(searchQuery.value);
            }, DEBOUNCE_MS);
        };
        // Perform actual search with axios
        const performSearch = async (query) => {
            try {
                const response = await axios.post(API_ENDPOINT, {
                    q: query
                });
                searchResults.value = response.data.data.products || [];
            }
            catch (error) {
                console.error('Search error:', error);
                if (axios.isAxiosError(error)) {
                    const axiosError = error;
                    if (axiosError.response) {
                        searchError.value = `Search failed: ${axiosError.response.status} ${axiosError.response.statusText}`;
                    }
                    else if (axiosError.request) {
                        searchError.value = 'No response from server. Please check your connection.';
                    }
                    else {
                        searchError.value = 'An error occurred while searching.';
                    }
                }
                else {
                    searchError.value = 'An unexpected error occurred.';
                }
                searchResults.value = [];
            }
            finally {
                isSearching.value = false;
            }
        };
        // Handle product click
        const handleProductClick = () => {
            closeSearch();
        };
        // Close on escape key
        watch(isSearchOpen, (newValue) => {
            if (newValue) {
                const handleEscape = (e) => {
                    if (e.key === 'Escape') {
                        closeSearch();
                    }
                };
                window.addEventListener('keydown', handleEscape);
                return () => {
                    window.removeEventListener('keydown', handleEscape);
                };
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    onClick: toggleSearch,
                    class: _normalizeClass(["search-icon-btn", { 'active': isSearchOpen.value }]),
                    "aria-label": "Toggle product search"
                }, [
                    _createElementVNode("img", {
                        src: _unref(assetUrl)('/images/trade-site/search-thicker.svg'),
                        alt: "Search",
                        class: "search-icon"
                    }, null, 8, _hoisted_2)
                ], 2),
                _createVNode(_Transition, { name: "search-overlay" }, {
                    default: _withCtx(() => [
                        (isSearchOpen.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "search-overlay",
                                onClick: closeSearch
                            }, [
                                _createElementVNode("div", {
                                    class: "search-container",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _withDirectives(_createElementVNode("input", {
                                            ref_key: "searchInput",
                                            ref: searchInput,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                            type: "text",
                                            placeholder: "Search products by name, viscosity, or specification...",
                                            class: "search-input",
                                            onInput: handleSearch,
                                            onKeydown: _withKeys(closeSearch, ["esc"])
                                        }, null, 544), [
                                            [_vModelText, searchQuery.value]
                                        ]),
                                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "search-input-icon" }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round"
                                            }, [
                                                _createElementVNode("circle", {
                                                    cx: "11",
                                                    cy: "11",
                                                    r: "8"
                                                }),
                                                _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                                            ])
                                        ], -1))
                                    ]),
                                    (searchQuery.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            (isSearching.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                                                        _createElementVNode("div", { class: "loading-spinner" }, null, -1),
                                                        _createElementVNode("p", null, "Searching products...", -1)
                                                    ]))]))
                                                : (searchError.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                        _cache[4] || (_cache[4] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "48",
                                                            height: "48",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            "stroke-width": "1.5",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round"
                                                        }, [
                                                            _createElementVNode("circle", {
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10"
                                                            }),
                                                            _createElementVNode("line", {
                                                                x1: "12",
                                                                y1: "8",
                                                                x2: "12",
                                                                y2: "12"
                                                            }),
                                                            _createElementVNode("line", {
                                                                x1: "12",
                                                                y1: "16",
                                                                x2: "12.01",
                                                                y2: "16"
                                                            })
                                                        ], -1)),
                                                        _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Search Error", -1)),
                                                        _createElementVNode("p", null, _toDisplayString(searchError.value), 1)
                                                    ]))
                                                    : (searchResults.value.length > 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (product) => {
                                                                return (_openBlock(), _createElementBlock("a", {
                                                                    key: product.id,
                                                                    href: product.url,
                                                                    class: "result-item",
                                                                    onClick: handleProductClick
                                                                }, [
                                                                    (product.image)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                                            _createElementVNode("img", {
                                                                                src: product.image,
                                                                                alt: product.code
                                                                            }, null, 8, _hoisted_10)
                                                                        ]))
                                                                        : _createCommentVNode("", true),
                                                                    _createElementVNode("div", _hoisted_11, [
                                                                        _createElementVNode("h4", _hoisted_12, _toDisplayString(product.code), 1),
                                                                        _createElementVNode("span", {
                                                                            class: "result-badge",
                                                                            style: _normalizeStyle({ backgroundColor: product.hexcode })
                                                                        }, _toDisplayString(product.title), 5)
                                                                    ])
                                                                ], 8, _hoisted_8));
                                                            }), 128))
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[6] || (_cache[6] = [
                                                                _createElementVNode("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "48",
                                                                    height: "48",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    "stroke-width": "1.5",
                                                                    "stroke-linecap": "round",
                                                                    "stroke-linejoin": "round"
                                                                }, [
                                                                    _createElementVNode("circle", {
                                                                        cx: "11",
                                                                        cy: "11",
                                                                        r: "8"
                                                                    }),
                                                                    _createElementVNode("path", { d: "m21 21-4.35-4.35" })
                                                                ], -1),
                                                                _createElementVNode("h4", null, "No products found", -1),
                                                                _createElementVNode("p", null, "Try searching with different keywords or product specifications", -1)
                                                            ]))]))
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
